module.exports = __webpack_public_path__ + "static/Uizard-vs-Figma-a37b23e6964b38d1301845bfd349c138.png";